import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React from "react";
import { SubTableCols } from "./MCSTables";
import { Box, Typography } from "@mui/material";
import { lightTable } from "../../../styles/muiProps";

export default function SubTable({ row }) {
  // const data = row?.subRows?.map(r=>{
  //     return{
  //         id: r.id,
  //         poNumber: r.po?.poNumber,
  //         poDate: r.po?.poDate,
  //         ...r
  //     }
  // })
  console.log(row?.subRows);

  const table = useMaterialReactTable({
    columns: SubTableCols,
    data: row?.subRows?.map((r) => r.original) || [],
    ...lightTable,
  });
  return (
    <Box sx={{ width: "100%" }}>
      <Typography sx={{ m: 1, mt: 0 }}>History Records:</Typography>

      <MaterialReactTable table={table} />
    </Box>
  );
}
